import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from '@emotion/styled';
export var MessageContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-left: ", ";\n"])), function (props) {
  return props.isSearch ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)";
});
export var MessageList = styled.ul(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding-left: ", ";\n"])), "var(--ds-space-300, 24px)");